// This is for the production site, which is hosted at https://docs.angular.lat/
export const environment = {
  firebase: {
    apiKey: 'AIzaSyD2ofxXTZHHcsmaAt5H9Zd17vj2ne57mIQ',
    authDomain: 'angular-latino.firebaseapp.com',
    databaseURL: 'https://angular-latino.firebaseio.com',
    projectId: 'angular-latino',
    storageBucket: 'angular-latino.appspot.com',
    messagingSenderId: '1050547922973',
    appId: '1:1050547922973:web:0eb42eb1f83938c1317ef4',
    measurementId: 'G-8EYEC7KL0R'
  },
  production: true,
  mode: 'stable'
};
